import styled from 'styled-components';

export const Container = styled.main`
    width: 100%;
    height: 100vh;
    padding: 10px;
    background: linear-gradient(120deg, #252525, #444);

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`